'use client'

import type { GlobalErrorPageProps } from '@/components/global-error-page/global-error-page.types'

import { NextIntlClientProvider } from 'next-intl'
import React from 'react'

import ErrorPage from '@/app/error'
import { useGlobalErrorPage } from '@/components/global-error-page/batons/use-global-error-page'
import { PublicHeaderBar } from '@/components/public-header-bar'
import { MobileHeaderBar } from '@maestro/commerce-blocks/components/mobile-header-bar'
import { theme } from '@maestro/local/theme'

/**
 * Polar-specific shell for app/global-error.tsx. It renders outside the root
 * layout
 */
export default function GlobalErrorPage(props: GlobalErrorPageProps) {
  const { error, reset, bodyClassName } = props
  const { locale, messages, errorTitle } = useGlobalErrorPage(error)

  return (
    <html lang={locale}>
      <body className={bodyClassName}>
        <PublicHeaderBar logoDestination={theme().urls.home} />
        {messages && (
          <NextIntlClientProvider
            locale={locale}
            messages={messages}
            timeZone={theme().site.timeZone}
          >
            <MobileHeaderBar title={errorTitle} isVisibleCloseButton={false} />
            <main>
              <div
                className="container no-header no-footer"
                id="main__content"
                tabIndex={-1}
              >
                <ErrorPage error={error} reset={reset} />
              </div>
            </main>
          </NextIntlClientProvider>
        )}
      </body>
    </html>
  )
}
